import { useCallback } from 'react';
import { useAppDispatch } from 'store/hooks';
import authActions from '../actions';
import authSelectors from '../selectors';
import { ILoginRequest } from '../../interfaces/api';

const useLogin = () => {
  const dispatch = useAppDispatch();
  const status = authSelectors.getStatus();
  const user = authSelectors.getUser();
  const errorMessage = authSelectors.getErrorMessage();
  const isLoading = status === 'loading';
  const isAuthenticated = status === 'authenticated';

  const login = useCallback((data: ILoginRequest) => {
    dispatch(authActions.login.fetch(data));
  }, [dispatch]);

  const logout = useCallback(() => {
    dispatch(authActions.logout.fetch());
  }, [dispatch]);

  return {
    login,
    logout,
    status,
    user,
    errorMessage,
    isLoading,
    isAuthenticated,
  };
};

export default useLogin;
